import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  CircularProgress,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InvestmentsTable from "./InvestmentsTable";
import DocumentVault from "./DocumentVault";
import Announcements from "./Announcements";
import Activity from "./Activity";
import Opportunities from "./Opportunities";
import SharedAccess from "./SharedAccess";
import FileExplorer from "./FileExplorer";
import AdminConsole from "./AdminConsole";
import { useSelector } from "react-redux";
import InvestmentAnalytics from "./InvestmentAnalytics";
import CreateProductForm from "./CreateProductForm";
import InvestmentMarketplace from "./InvestmentMarketplace";
import ApplicationsManager from "./ApplicationsManager";

function Portfolio() {
  const [userRole, setUserRole] = useState("admin"); // Main user role
  const [view, setView] = useState("portfolio");
  const [selectedInvestor, setSelectedInvestor] = useState(null);
  const [selectedInvestment, setSelectedInvestment] = useState(null);

  let configVariables = useSelector((state) => state.config.baseConfig);
  console.log("sessionStorage_user=========", JSON.parse(sessionStorage.getItem("user")));
  let userSecurityRoles = JSON.parse(sessionStorage.getItem("user"))?.payload
    ?.body?.Securityuserrole;
  // Determines if we are looking at the "Master Admin" view or a "Specific Investor" view
  const isDetailView = view === "investor-detail" && selectedInvestor;

  useEffect(() => {
    // 1. Normalize user roles to an array to handle single or multiple roles
    const userRoles = Array.isArray(userSecurityRoles)
      ? userSecurityRoles
      : [userSecurityRoles];

    // 2. Helper to safely parse comma-separated IDs from the Redux config
    const parseConfigIds = (ids) =>
      ids
        ?.toString()
        .split(",")
        .map((id) => Number(id.trim())) || [];

    const adminRolesArray = parseConfigIds(
      configVariables?.portfolioAdminRoleIds,
    );
    const delegateRolesArray = parseConfigIds(configVariables?.delegateRoleIds);

    // 3. Check membership for Admin and Delegate roles
    const isAdmin = userRoles.some((role) =>
      adminRolesArray.includes(Number(role?.roleid)),
    );

    const isDelegate = userRoles.some((role) =>
      delegateRolesArray.includes(Number(role?.roleid)),
    );

    // 4. Set role dynamically based on priority
    if (isAdmin) {
      setUserRole("admin");
    } else if (isDelegate) {
      setUserRole("delegate");
    } else {
      setUserRole("investor");
    }
  }, [userSecurityRoles, configVariables]);

  const handleInvestorClick = (investor) => {
    if (userRole === "admin") {
      setSelectedInvestor(investor);
      setView("investor-detail");
    }
  };

  const handleBackToMain = () => {
    setSelectedInvestor(null);
    setView("portfolio");
  };

  const handleViewAnalytics = (investment) => {
    setSelectedInvestment(investment);
    setView("investment-analytics");
  };

  const handleCreateProduct = () => {
    setView("create-product");
  };

  const handleViewMarketplace = () => setView("marketplace");

  const handleViewDocs = (row) => {
    console.log("row=======", row);
    setView("explorer");
  };

  const handleViewApplications = () => {
    setView("applications");
  };

  console.log("SelectedInvestor-----------", selectedInvestor);
  console.log("isDetailView-----------", isDetailView);

  return (
    <Box
      className="page-container"
      sx={{ paddingBottom: "80px", background: "#f4f7f9" }}
    >
      {/* FILE EXPLORER VIEW (Full Screen Overlay) */}
      {view === "explorer" && (
        <FileExplorer
          onBack={() => {
            setView(isDetailView ? "investor-detail" : "portfolio");
            setSelectedInvestor(null);
          }}
        />
      )}

      {view === "adminconsole" && (
        <AdminConsole
          onExit={() => setView(isDetailView ? "investor-detail" : "portfolio")}
          userRole={userRole}
        />
      )}

      {view === "investment-analytics" && (
        <InvestmentAnalytics
          investment={selectedInvestment}
          onBack={() => setView("investor-detail")}
        />
      )}

      {view === "create-product" && (
        <CreateProductForm onBack={() => setView("portfolio")} />
      )}

      {view === "marketplace" && (
        <InvestmentMarketplace onBack={handleBackToMain} userRole={userRole} />
      )}

      {view === "applications" && (
        <ApplicationsManager onBack={() => setView("portfolio")} />
      )}

      {/* DASHBOARD VIEW (Used for both Admin Home and Investor Detail) */}
      {(view === "portfolio" || view === "investor-detail") && (
        <>
          {/* <Box className="header-card" sx={{ borderLeft: isDetailView ? '4px solid #1976d2' : 'none' }}>
                        <Box display="flex" alignItems="center" gap={2}>
                            {isDetailView && (
                                <IconButton onClick={handleBackToMain}><ArrowBackIcon /></IconButton>
                            )}
                            <Box>
                                <Typography variant="h5" fontWeight="bold">
                                    {isDetailView 
                                        ? `${selectedInvestor.name.toUpperCase()} — PROFILE` 
                                        : "THE HOLT XCHANGE ADMIN"}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    {isDetailView 
                                        ? `Viewing details for ${selectedInvestor.email}` 
                                        : "Management Dashboard | Aggregate Investor Data"}
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            {isDetailView ? (
                                <Button variant="contained" color="primary" size="small">Generate Report</Button>
                            ) : (
                                <Button onClick={()=> setView('adminconsole') } variant="outlined" size="small">Global Settings</Button>
                            )}
                        </Box>
                    </Box> */}

          <Box className="header-card">
            <Box display="flex" alignItems="center" gap={2}>
              <Box>
                {userRole == "admin" ? (
                  <>
                    <Typography variant="h5" fontWeight="bold">
                      THE HOLT XCHANGE ADMIN
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Management Dashboard | Aggregate Investor Data
                    </Typography>
                  </>
                ) : userRole == "investor" ? (
                  <>
                    <Typography variant="h5" fontWeight="bold">
                      Welcome! Investor
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Investor Dashboard
                    </Typography>
                  </>
                ) : (
                  <>
                    <Typography variant="h5" fontWeight="bold">
                      Welcome! Delegate
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Delegate Dashboard
                    </Typography>
                  </>
                )}
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: 2 }}>
              {userRole === "admin" && (
                <>
                  <Button
                    variant="contained"
                    color="info"
                    onClick={() => setView("marketplace")}
                    sx={{ textTransform: "none" }}
                  >
                    View Investment Funds
                  </Button>

                  <Button 
                                    variant="contained" 
                                    color="warning" // Using warning (orange) to distinguish from Funds
                                    onClick={handleViewApplications}
                                    sx={{ textTransform: 'none', fontWeight: 'bold' }}
                                >
                                    View Applications
                                </Button>
                </>
              )}

              {(userRole === "investor" || userRole === "delegate") && (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleViewMarketplace}
                  sx={{ textTransform: "none", fontWeight: "bold" }}
                >
                  Exclusive Opportunities
                </Button>
              )}

              {(userRole == "admin" || userRole == "investor" ) && (
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      bgcolor: "#001529",
                      textTransform: "none",
                      "&:hover": { bgcolor: "#002140" },
                    }}
                    onClick={handleCreateProduct}
                  >
                    Create Investment Fund
                  </Button>
                  <Button
                    onClick={() => setView("adminconsole")}
                    variant="outlined"
                    size="small"
                    sx={{ textTransform: "capitalize" }}
                  >
                    Admin Console
                  </Button>
                </Box>
              )}
               {/* {(userRole == "admin" || userRole == "investor") && (
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Button
                    variant="contained"
                    size="small"
                    color="info"
                    sx={{ textTransform: "none" }}
                    onClick={handleApplicationReview}
                  >
                    View Applications
                  </Button>                  
                </Box>
              )} */}
            </Box>
          </Box>

          {/* Uniform Dashboard Grid Layout */}
          <Grid container spacing={3} sx={{ mb: 3 }}>
            <Grid item xs={12} md={5}>
              {/* Vault shows all docs for Admin, or investor-specific docs in detail view */}
              <DocumentVault
                onViewAll={() => setView("explorer")}
                userRole={userRole}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Announcements />
            </Grid>
            <Grid item xs={12} md={4}>
              <Activity />
            </Grid>
          </Grid>

          <Grid container spacing={3} sx={{ mb: 3 }}>
            <Grid item xs={12}>
              {/* If Admin is on main portfolio: Show Investor List.
                                If Admin is in detail view: Show that investor's portfolio.
                            */}
              <InvestmentsTable
                onRowClick={!isDetailView ? handleInvestorClick : null}
                onBack={isDetailView ? handleBackToMain : null}
                // overrideRole={userRole}
                overrideRole={isDetailView ? "investor" : userRole}
                selectedInvestorDetails={selectedInvestor}
                onViewInvestmentDetails={handleViewAnalytics}
                onViewDocs={handleViewDocs}
                // overrideRole={isDetailView ? "investor" : "admin"}
              />
            </Grid>
          </Grid>

          {/* <Grid container spacing={3}>
            <Grid item xs={12}>
              <Opportunities />
            </Grid>
            <Grid item xs={12}>
              <SharedAccess />
            </Grid>
          </Grid> */}
        </>
      )}
    </Box>
  );
}

export default Portfolio;
